/*
 *
 * orderPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'orderPage';
export const initialState = {
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    query: {
        key: '',
        id: '',
    },
};

/* eslint-disable no-param-reassign, default-case */
function orderPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_QUERY:
                draft.query = action.query;
                return draft;
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default orderPageReducer;
